

export default class TeacherList {
    constructor() {
        TeacherList._filterPrepods();

        $('#prepods_all').on('change blur', TeacherList._filterPrepods);
    }

    // Prepods filter
    static _filterPrepods() {
        let checked_input = $('#prepods_all .prepod_filter input:checked');
        let current_filter = $(checked_input).attr('id'),
            active_tab = $('#prepods_all .main_prepod_section .wrapper > div');

        if ($(active_tab).hasClass(current_filter)) {
            $(active_tab).css("display", "none");
            for (let i = 0; i < active_tab.length; i++) {
                let curentTab = active_tab[i];
                if ($(curentTab).hasClass(current_filter)) {
                    $(curentTab).fadeIn(100);
                }
            }
        }
    }

}


